import React from 'react'
import './App.css'
import './Tickets.css'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import { IoTicketOutline, IoLocationOutline, IoCalendarOutline, IoSearch } from 'react-icons/io5'
import TopBarProgress from 'react-topbar-progress-indicator'
import Header from './layouts/Header'
import SideNavCust from './layouts/SideNavCust'
import SideNav from './layouts/SideNav'
import SideNavAff from './layouts/SideNavAff'
import { BiMenu, BiChevronRight } from 'react-icons/bi'
import { API_URL } from './config'

const formatZAR = (amount) => {
  const n = Number(amount)
  if (Number.isNaN(n)) return null
  return new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR' })
    .format(n)
    .replace(/\s/g, '')
}

/* Only keep successful transactions (drops abandoned / cancelled / failed / pending).
   Adjust STATUS_FIELDS / SUCCESS_VALUES to match your API response. */
const STATUS_FIELDS = [
  'status',
  'paymentstatus',
  'transactionstatus',
  'payment_status',
  'transaction_status',
]
const SUCCESS_VALUES = ['success', 'successful', 'paid', 'complete', 'completed', 'approved']

const isSuccessful = (ticket) => {
  const field = STATUS_FIELDS.find((f) => ticket[f] !== undefined && ticket[f] !== null)
  if (!field) return true // no status field returned: nothing to filter on
  return SUCCESS_VALUES.includes(String(ticket[field]).trim().toLowerCase())
}

const onlySuccessful = (data) => (Array.isArray(data) ? data.filter(isSuccessful) : [])

/* Poster with a lettered fallback when the image is missing or fails */
class Poster extends React.Component {
  state = { failed: false }

  render() {
    const { src, name } = this.props
    return (
      <div className="tk-poster">
        <span className="tk-poster__letter">{(name || '?').charAt(0).toUpperCase()}</span>
        {!this.state.failed && src && (
          <img src={src} alt="" onError={() => this.setState({ failed: true })} />
        )}
      </div>
    )
  }
}

class Tickets extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    this.state = {
      query: '',
      password: '',
      response: '',
      error: '',
      errorDisplay: 'none',
      tickets: [],
      loadBarProgress: true,
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
    const customername = localStorage.getItem('customername')
    const customerid = localStorage.getItem('customerid')
    document.title = customername

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERTICKETS&subquery=GETTICKETS&customerid=${customerid}`,
      {
        withCredentials: true,
      },
    )
      .then((response) => {
        if (response.data.val == 0) {
          this.setState({ tickets: [], loadBarProgress: false })
        } else {
          this.setState({ tickets: onlySuccessful(response.data), loadBarProgress: false })
        }
      })
      .catch((error) => console.log(error))
  }

  tickets = () => {
    const customerid = localStorage.getItem('customerid')
    const customername = localStorage.getItem('customername')

    return (
      <div>
        {this.state.loadBarProgress ? (
          <div className="tk-list">
            {[0, 1, 2].map((i) => (
              <div className="tk-card tk-card--skeleton" key={i}>
                <div className="tk-poster" />
                <div className="tk-card__body">
                  <div className="tk-skel tk-skel--title" />
                  <div className="tk-skel tk-skel--line" />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <>
            {this.state.tickets.length < 1 ? (
              <div className="tk-empty">
                <div className="tk-empty__icon">
                  <IoTicketOutline size={28} />
                </div>
                <h3>No data found</h3>
              </div>
            ) : (
              <div className="tk-list">
                {this.state.tickets.map((item, index) => {
                  let poster = `${API_URL}/apps/kscanner/posters/${item.businessid}/${item.eventid}/${item.thumbnail}`
                  const cost = formatZAR(item.totalcost)
                  const admissions = Number(item.admissions)

                  return (
                    <Link
                      key={index}
                      className="tk-card"
                      to={{
                        pathname: '/previewtickets',
                        state: {
                          customername: customername,
                          customerid: customerid,
                          eventid: item.eventid,
                          transactiondate: item.transactiondate,
                          venue: item.venue,
                          eventname: item.eventname,
                          eventtime: item.eventtime,
                          eventday: item.eventday,
                          yearcreated: item.yearcreated,
                          theme: item.theme,
                          admissions: item.admissions,
                          totalcost: item.totalcost,
                        },
                      }}
                    >
                      <Poster src={item.thumbnail ? poster : null} name={item.eventname} />

                      <div className="tk-card__body">
                        <div className="tk-card__title">{item.eventname}</div>

                        <div className="tk-card__meta">
                          {item.eventday && (
                            <span>
                              <IoCalendarOutline /> {item.eventday}
                            </span>
                          )}
                          {item.venue && (
                            <span className="tk-card__venue">
                              <IoLocationOutline /> {item.venue}
                            </span>
                          )}
                        </div>

                        <div className="tk-card__tags">
                          {!Number.isNaN(admissions) && (
                            <span className="tk-tag">
                              {admissions} {admissions === 1 ? 'admission' : 'admissions'}
                            </span>
                          )}
                          {cost && <span className="tk-tag">{cost}</span>}
                        </div>
                      </div>

                      <BiChevronRight className="tk-card__arrow" size={22} />
                    </Link>
                  )
                })}
              </div>
            )}
          </>
        )}
      </div>
    )
  }

  searchQuery = (text) => {
    let value = text.target.value
    this.setState({ query: value })
    let query = value.split(' ').join('+')
    this.setState({ isLoading: true, loadingMerch: false })
    const customerid = localStorage.getItem('customerid')

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERTICKETS&subquery=SEARCHTICKETS&search=${query}&customerid=${customerid}`,
      {
        withCredentials: true,
      },
    )
      .then((response) => {
        if (response.data.val == 0) {
          this.setState({
            tickets: [],
          })
        } else {
          this.setState({
            tickets: onlySuccessful(response.data),
          })
        }
      })
      .catch((error) => console.log(error))
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  render() {
    if (localStorage.getItem('customerid') === null) {
      return <Redirect to="/login" />
    } else {
    }

    const { loadBarProgress } = this.state
    const accounttype = localStorage.getItem('accounttype')
    const { collapsed, isMobile } = this.state

    return (
      <div className="view">
        {loadBarProgress && <TopBarProgress />}
        <Header />
        {accounttype === 'customer' ? (
          <SideNavCust collapsed={this.state.collapsed} onToggle={this.handleToggle} />
        ) : accounttype === 'business' ? (
          <SideNav collapsed={this.state.collapsed} onToggle={this.handleToggle} />
        ) : (
          <SideNavAff collapsed={this.state.collapsed} onToggle={this.handleToggle} />
        )}

        {isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={this.handleToggle} />
        )}

        {isMobile && collapsed && (
          <label className="mobile-toggle" onClick={this.handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <main
          className="tk-page"
          style={{
            marginTop: 'var(--header-h)',
            marginLeft: isMobile ? 0 : collapsed ? '76px' : '252px',
          }}
        >
          <div className="tk-container">
            <button type="button" className="tk-back" onClick={() => this.props.history.goBack()}>
              <IoIosArrowBack size={18} />
              <span>Back</span>
            </button>

            <div className="tk-head">
              <div>
                <h1>My Tickets</h1>
              </div>

              <div className="tk-search">
                <IoSearch className="tk-search__icon" size={16} />
                <input
                  type="text"
                  placeholder="Search tickets by event name"
                  value={this.state.query}
                  onChange={this.searchQuery}
                  autoComplete="off"
                />
              </div>
            </div>

            {this.tickets()}
          </div>
        </main>

        <div
          className="error-login"
          style={{ display: this.state.errorDisplay, textAlign: 'center' }}
        >
          {this.state.error}
        </div>
      </div>
    )
  }
}

export default Tickets
